// test2446
(2446 && 0);
